import { Component, Input } from '@angular/core';

@Component({
    selector: 'error-field-display',
    template: `
    <style>
        .fix-error-icon {
            top: 27px;
        }
    </style>
    <div *ngIf="displayError" >
        <span class="sr-only">(error)</span>
        <div class="error-msg">
        {{ errorMsg }}
      </div>
    </div>`
})

export class ErrorFieldDisplayComponent {
    @Input() errorMsg: string;
    @Input() displayError: boolean;
}



// WEBPACK FOOTER //
// ./src/app/error-field-display.component.ts